module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAtCAMAAACZIrtaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF2evjy9rS0ebc6urr9PX1ydLO1NXV293c6fLszuHY/P394+Pk7vXx0dHR////3u7pkAGY6QAAAPZJREFUeNqU0sEWxBAMBdAUQVXk//92ROm8TrsZ53RzG8SDWmtBc204qH9ZlRyR5nzHOZzLC4u7VEknNkB1b0gTPWL+GwPuLi/o5NG8KqeJ2KX4ifTFnV9Q94WZXo5ZGZXKwEP4XmsYRTYsrYYiwoo6K3E+hRFIV/e7ZgsRkNKJLcD0TeqJbVfARK3mrJgyG2LfdngZ0+/KItZSpXuhf0TXt5kpERYOTCk6XPEwPDAjllgMCya3rYvzPbrN7eNQbIUrZBvO9jnWo/Un9lA4Xs87yNRZeEaXliKWpdb5wq79CIYecPzoOhpCtP18+8V+q+WJ1/gIMABb9ixY0guL/QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/NJ.png
// module id = CT4Q
// module chunks = 1